import React, { useState, useEffect, useRef } from "react";
import HeroSection from "./HeroSection";

import hvacguy from "../../../Assets/hvacguy.png";
import cleanngguy from "../../../Assets/cleaner.png";
import waterguy from "../../../Assets/waterguy.png";

const slides = [
  { image: cleanngguy },
  { image: waterguy },
  { image: hvacguy },
  { image: cleanngguy },
  { image: waterguy },
  { image: hvacguy }, // optional repeat for rhythm
];

const AUTO_DELAY = 2000;

const HeroCarousel = () => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const startX = useRef(0);
  const deltaX = useRef(0);

  /* ================= AUTO SLIDE ================= */
  useEffect(() => {
    if (paused) return;

    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, AUTO_DELAY);

    return () => clearInterval(timer);
  }, [paused]);

  /* ================= TOUCH SWIPE ================= */
  const onTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const onTouchMove = (e) => {
    deltaX.current = e.touches[0].clientX - startX.current;
  };

  const onTouchEnd = () => {
    if (Math.abs(deltaX.current) > 60) {
      setIndex((prev) =>
        deltaX.current < 0
          ? (prev + 1) % slides.length
          : (prev - 1 + slides.length) % slides.length
      );
    }
    deltaX.current = 0;
  };

  return (
    <>
      <style>{`
        .hero-carousel {
          width: 100%;
          overflow: hidden;
          position: relative;
        }

        .hero-track {
          display: flex;
          width: ${slides.length * 100}vw;
          transform: translate3d(-${index * 100}vw, 0, 0);
          transition: transform 900ms cubic-bezier(0.22, 1, 0.36, 1);
          will-change: transform;
        }

        .hero-slide {
          width: 100vw;
          flex-shrink: 0;
        }
      `}</style>

      <div
        className="hero-carousel"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <div className="hero-track">
          {slides.map((s, i) => (
            <div className="hero-slide" key={i}>
              <HeroSection mainImage={s.image} />
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default HeroCarousel;
